// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"4542ead9","182":"bf9cc420","228":"eb2074a4","350":"cdb0192b","453":"d855a71b","537":"ce1cffd8","739":"4536202e","827":"328378d9"}[chunkId] + ".chunk.js";
};